import React, {useState} from "react";
import {useAppSelector} from "../../../../hooks";
import {BackProjType} from "../../../../features/schemaManageSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import EditJoin from "./EditJoin";
import EditNull from "./EditNull";


export default function EditNullableFieldsIcon({tableType}: {
    tableType: BackProjType,
}) {
    const [isAddingNew, setIsAddingNew] = useState(false)
    const closeEditing = () => setIsAddingNew(false);

    const mode = useAppSelector(state => state.schemaManage.back.mode);

    if (mode !== "edit" || tableType === "static")
        return null

    return <>
        <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsAddingNew(true)}>
            <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
        </button>
        {isAddingNew &&
            <EditNull closeEditing={closeEditing}/>}
    </>


}
